<template>
  <div>
    <el-table
      :data="[
        { name: '面辅料价格', k1: 'cost_price_mtrl', k2: 'quta_taxrate_mtrl', k3: 'tax_price_mtrl', k4: 'tax_toatl_mtrl' },
        { name: '工资', k1: 'cost_price_rate', k2: 'quta_taxrate_sala', k3: 'tax_price_rate', k4: 'tax_toatl_rate' }
      ]"
      :summary-method="getSummaries"
      border
      show-summary
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="name" width="180"></el-table-column>
      <el-table-column label="成本价">
        <template v-slot="scope">
          <el-form-item v-if="scope.row.k1 === 'cost_price_mtrl'" :prop="scope.row.k1" label-width="0">
            <el-input
              v-model="costPriceOfFabricsAndAuxiliaryMaterials"
              disabled
              maxlength="11"
              placeholder="暂无成本价"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item v-else :prop="scope.row.k1" label-width="0">
            <el-input v-model="qutaForm[scope.row.k1]" disabled maxlength="11" placeholder="暂无成本价" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="税点">
        <template v-slot="scope">
          <el-form-item :prop="scope.row.k2" label-width="0">
            <el-input v-model="qutaForm[scope.row.k2]" maxlength="11" placeholder="暂无税点" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="含税金额">
        <template v-slot="scope">
          <el-form-item v-if="scope.row.k3 === 'tax_price_mtrl'" :prop="scope.row.k3" label-width="0">
            <el-input v-model="costTaxInclusiveAmount" disabled maxlength="11" placeholder="暂无含税金额" show-word-limit></el-input>
          </el-form-item>
          <el-form-item v-else :prop="scope.row.k3" label-width="0">
            <el-input v-model="salaTaxInclusiveAmount" disabled maxlength="11" placeholder="暂无含税金额" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="税额合计">
        <template v-slot="scope">
          <el-form-item v-if="scope.row.k4 === 'tax_toatl_mtrl'" :prop="scope.row.k4" label-width="0">
            <el-input v-model="costTotalTaxAmount" disabled maxlength="11" placeholder="暂无税额合计" show-word-limit></el-input>
          </el-form-item>
          <el-form-item v-else :prop="scope.row.k4" label-width="0">
            <el-input v-model="salaTotalTaxAmount" disabled maxlength="11" placeholder="暂无税额合计" show-word-limit></el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';

export default {
  name: 'QutaParameter',
  props: {
    qutaForm: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    // 面辅料价格成本价
    costPriceOfFabricsAndAuxiliaryMaterials() {
      // 面料
      let sum = this.qutaForm.listOfRawMaterials.reduce((accumulator, currentItem) => {
        return accumulator.plus(new BigNumber(currentItem.purc_price || 0));
      }, new BigNumber(0));
      // 辅料
      let sum2 = this.qutaForm.auxiliaryMaterialList.reduce((accumulator, currentItem) => {
        return accumulator.plus(new BigNumber(currentItem.mtrl_total_price || 0));
      }, new BigNumber(0));
      sum2 = sum2
        .plus(this.qutaForm.quta_emcd_price || 0)
        .plus(this.qutaForm.freight_price || 0)
        .plus(this.qutaForm.carton_price || 0)
        .plus(this.qutaForm.bag_prkg_price || 0);
      let total = sum.plus(sum2);
      if (!total.isFinite()) {
        this.qutaForm.cost_price_mtrl = 0.0;
        return 0.0;
      }
      this.qutaForm.cost_price_mtrl = total.toFixed(4);
      return total.toFixed(4);
    },
    costTaxInclusiveAmount() {
      let temp = new BigNumber(this.qutaForm.quta_taxrate_mtrl).times(this.qutaForm.cost_price_mtrl);
      if (!temp.isFinite()) {
        this.qutaForm.tax_price_mtrl = 0.0;
        return 0.0;
      }
      this.qutaForm.tax_price_mtrl = temp.toFixed(4);
      return temp.toFixed(4);
    },
    salaTaxInclusiveAmount() {
      let temp = new BigNumber(this.qutaForm.cost_price_rate).times(this.qutaForm.quta_taxrate_sala);
      if (!temp.isFinite()) {
        this.qutaForm.tax_price_rate = 0.0;
        return 0.0;
      }
      this.qutaForm.tax_price_rate = temp.toFixed(4);
      return temp.toFixed(4);
    },
    costTotalTaxAmount() {
      let temp = new BigNumber(this.qutaForm.tax_price_mtrl).minus(this.qutaForm.cost_price_mtrl);
      if (!temp.isFinite()) {
        this.qutaForm.tax_toatl_mtrl = 0.0;
        return 0.0;
      }
      this.qutaForm.tax_toatl_mtrl = temp.toFixed(4);
      return temp.toFixed(4);
    },
    salaTotalTaxAmount() {
      let temp = new BigNumber(this.qutaForm.tax_price_rate).minus(this.qutaForm.cost_price_rate);
      if (!temp.isFinite()) {
        this.qutaForm.tax_toatl_rate = 0.0;
        return 0.0;
      }
      this.qutaForm.tax_toatl_rate = temp.toFixed(4);
      return temp.toFixed(4);
    }
  },
  methods: {
    getSummaries() {
      return [
        '合计',
        new BigNumber(this.qutaForm.cost_price_mtrl).plus(this.qutaForm.cost_price_rate).toNumber(),
        '',
        new BigNumber(this.qutaForm.tax_price_mtrl).plus(this.qutaForm.tax_price_rate).toNumber(),
        new BigNumber(this.qutaForm.tax_toatl_mtrl).plus(this.qutaForm.tax_toatl_rate).toNumber()
      ];
    },
    // 税点变化
    taxPointChange(val) {
      this.$emit('taxPointChange', val.$index);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__footer-wrapper {
  font-size: 1.17em;
  font-weight: 900;
}

::v-deep .el-table__footer-wrapper .el-table_1_column_2 {
  color: #c70e0e;
}

::v-deep .el-table__footer-wrapper .el-table_1_column_4 {
  color: #c70e0e;
}

::v-deep .el-table__footer-wrapper .el-table_1_column_5 {
  color: #c70e0e;
}
</style>
